import axios, { type AxiosInstance, type CreateAxiosDefaults } from "axios"
import { AuthService } from "../auth/auth_service";

let saved_client: AxiosInstance | null = null;

export function getClient(extraConfig: CreateAxiosDefaults<unknown> = {}): AxiosInstance {
  if (saved_client) {
    return saved_client;
  }

  const client = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },

    ...extraConfig
  });

  client.interceptors.request.use(async (config) => {
    const token = await AuthService.getInstance().getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  });
  saved_client = client;
  return client;
}
